import JSZip from "jszip";

export type SkillZipFileEntry = {
  file_path: string;
  url?: string | null;
};

export async function downloadSkillFilesAsZip(
  files: SkillZipFileEntry[],
  skillName: string,
): Promise<void> {
  const zip = new JSZip();
  await Promise.all(
    files.map(async (file) => {
      if (!file.url) return;
      const response = await fetch(file.url);
      if (!response.ok) {
        throw new Error(
          `Could not download "${file.file_path}" (${response.status})`,
        );
      }
      const blob = await response.blob();
      zip.file(file.file_path, blob);
    }),
  );
  const content = await zip.generateAsync({ type: "blob" });
  const objectUrl = URL.createObjectURL(content);
  const a = document.createElement("a");
  a.href = objectUrl;
  a.download = `${skillName}.zip`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(objectUrl);
}
